import React from "react";
import { Phone, ClipboardCheck, Cog, BadgeCheck } from "lucide-react";
import Reveal from "./Reveal";
import { motion } from "framer-motion";

const steps = [
  { n: "01", icon: Phone, title: "Ne contactezi", desc: "Telefon, formular sau WhatsApp. Răspundem rapid în program lucrător." },
  { n: "02", icon: ClipboardCheck, title: "Diagnosticăm", desc: "Evaluare gratuită on-site sau remote. Estimare clară de timp și cost." },
  { n: "03", icon: Cog, title: "Implementăm", desc: "Lucrăm curat, documentăm și păstrăm garanția pe componente." },
  { n: "04", icon: BadgeCheck, title: "Garantăm", desc: "Suport post-intervenție 30 de zile. Pentru abonați — 24/7." },
];

export default function Process() {
  return (
    <section id="proces" data-testid="process-section" className="py-24 lg:py-36 border-t border-line">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-16">
          <Reveal y={14} className="overline text-clay">
            CUM LUCRĂM
          </Reveal>
          <Reveal y={20} delay={0.1}>
            <h2 className="mt-4 font-display font-bold text-4xl sm:text-5xl tracking-[-0.03em]">
              Patru pași simpli, zero surprize.
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-y border-line">
          {steps.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ delay: i * 0.08, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`process-step-${s.n}`}
              className={`p-8 lg:p-10 border-line group hover:bg-sandwarm transition-colors ${
                i !== 0 ? "lg:border-l" : ""
              } ${i < 3 ? "border-b lg:border-b-0" : ""} ${i === 1 ? "md:border-l" : ""} ${
                i === 3 ? "md:border-l lg:border-l" : ""
              }`}
            >
              <div className="flex items-start justify-between">
                <span className="font-display text-6xl font-black text-clay leading-none">
                  {s.n}
                </span>
                <s.icon size={22} className="text-inksoft group-hover:text-ink transition-colors" />
              </div>
              <h3 className="mt-10 font-display text-xl font-bold tracking-tight">{s.title}</h3>
              <p className="mt-3 text-sm text-inksoft leading-relaxed">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
